import './Project.css'
import '../../variable.css'
import Card from './Card';
import HeadLine from '../../HeadLine/HeadLine';

let Project = () => {
    let data = [
        {
            title: 'Book My Counsel',
            description: `An Advocate appointment booking platform makes it effortless for clients to connect with verified advocates. Advocates can create profiles and showcase their expertise, while clients can easily filter and book appointments. Get legal advice with ease and confidence on our website.`,
            techStack: 'Next Js | React Js | Javascript | Node Js | Express Js | MongoDb',
            gitHubLink: 'https://github.com/pratap562/book-my-counsel-frontend',
            deployedLink: 'https://book-my-counsel-frontend.vercel.app/',
            img: 'project3.png'

        },
        {
            title: 'Travel Pro',
            description: `A hotel and flight booking website allows users to search and book accommodations and flights online. It typically has a search function, a booking process, and may offer additional features such as the ability to manage and modify bookings or earn.`,
            techStack: 'HTML | CSS | JavaScript | Node | Express  | Mongodb',
            gitHubLink: 'https://github.com/anujrawat22/-rare-animal-2569',
            deployedLink: 'https://enchanting-pegasus-5127db.netlify.app/',
            deployedLink2: 'https://fabulous-biscotti-99e4f3.netlify.app/',
            img: 'project4.png'

        },
        {
            title: 'Pacifico Store',
            description: `Pacifico, an online fashion retail platform inspired by Myntra, used H&M API implemented auth and all basic crud operation Implemented user can purchase product add to cart add to wishlist data stored in json-serveradmin side as well`,
            techStack: 'HTML | CSS | JavaScript | Json-Server',
            gitHubLink: 'https://github.com/pratap562/pacific-clam-4161/',
            deployedLink: 'https://elaborate-melba-917bf4.netlify.app/index.html',
            img: 'project1.png'

        },
        {
            title: 'Youtubee',
            description: `YouTube app clone with the YouTube API. Users can browse trending videos, search for specific videos, and watch them in the app`,
            techStack: 'HTML | CSS | JavaScript | Youtube-Api',
            gitHubLink: 'https://github.com/pratap562/youtube_clone',
            deployedLink: 'https://lambent-baklava-c9dfe1.netlify.app/',
            img: 'youtube.png'

        }
    ]
    return (
        <div id='projects'>
            <HeadLine text='Projects' index='4' />
            {data.map((el) => (
                <Card title={el.title} description={el.description} techStack={el.techStack} gitHubLink={el.gitHubLink} deployedLink={el.deployedLink} img={el.img} ></Card>
            ))}
        </div>
    )
}
export default Project